import { FontWeight, Text } from '@lili/lili-frontend-common';
import { Trans } from 'react-i18next';

export const WelcomeBonusChip = () => {
  return (
    <div className='bg-[#7C8593] sm:bg-[#334763] px-[8px] py-[4px] rounded-[8px] w-[173px] sm:w-auto'>
      <Text.H10 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary-inverse'>
        <Trans
          i18nKey='pages.homePasswordless.wyomingValueProposal.welcomeBonus'
          components={{
            sup: <sup />,
          }}
        />
      </Text.H10>
    </div>
  );
};
